module.exports = __webpack_public_path__ + "img/hide.80df4153.svg";